import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

const mutateAddProject = async ({ data }: any) => {
  return await axiosAuth.post(`${PROJECT_API}`, data);
};

const useAddProjectMutation = (
  queryParams?: UseMutationOptions<any, Error, { data: any }, unknown>
) =>
  useMutation({
    mutationFn: mutateAddProject,
    ...queryParams,
  });

export default useAddProjectMutation;
